export default {
    productionSiteNotes : [],
    productionSiteNotesLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        search: null
    }
}